import { render } from "./swapspaceImg.vue?vue&type=template&id=e667380c"
import script from "./swapspaceImg.vue?vue&type=script&lang=js"
export * from "./swapspaceImg.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3815826973/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__